import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Eye, EyeOff, ArrowRight } from 'lucide-react';
import useAuthStore from '../store/authStore';
import toast from 'react-hot-toast';
import MarcoAcceso from '../components/MarcoAcceso';
import { useTextosAcceso } from '../utils/idiomaAcceso';

/**
 * Ingreso con el molde de la familia (Payroll360 SaaS, KNOC360): regla del espectro,
 * formulario con el logo a la izquierda y el panel índigo de Finance360 a la derecha.
 */
export default function Login() {
  const navigate = useNavigate();
  const { login, isLoading } = useAuthStore();
  const t = useTextosAcceso();

  // La cuenta sale del subdominio (acme.finance360.cr); en desarrollo se escribe a mano
  const getInitialTenantSlug = () => {
    const parts = window.location.hostname.split('.');
    if (parts.length > 2 || (parts.length === 2 && parts[1] === 'localhost')) {
      return parts[0];
    }
    return localStorage.getItem('tenantSlug') || 'ews';
  };

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [tenantSlug, setTenantSlug] = useState(getInitialTenantSlug());
  const isDevelopment = window.location.hostname === 'localhost';

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error(t.faltan);
      return;
    }
    if (!tenantSlug) {
      toast.error(t.faltaCuenta);
      return;
    }

    const result = await login(email, password, tenantSlug);
    if (result.success) {
      toast.success(t.bienvenido);
      navigate('/dashboard');
    } else {
      toast.error(result.error);
    }
  };

  return (
    <MarcoAcceso>
            <h2>{t.ingresar}</h2>
            <p className="bajada">{t.bajada}</p>

            <form onSubmit={handleSubmit} className="space-y-5">
              {isDevelopment && (
                <div>
                  <label htmlFor="cuenta">{t.cuenta}</label>
                  <input
                    id="cuenta"
                    type="text"
                    value={tenantSlug}
                    onChange={(e) => setTenantSlug(e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, ''))}
                    placeholder="mi-empresa"
                    className="campo"
                    required
                  />
                  <p className="ayuda">{t.cuentaAyuda}</p>
                </div>
              )}

              <div>
                <label htmlFor="correo">{t.correo}</label>
                <input
                  id="correo"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t.correoEj}
                  autoComplete="email"
                  className="campo"
                  required
                />
              </div>

              <div>
                <label htmlFor="clave">{t.clave}</label>
                <div className="relative">
                  <input
                    id="clave"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                    autoComplete="current-password"
                    className="campo"
                    style={{ paddingRight: 44 }}
                    required
                  />
                  <button type="button" className="ver" onClick={() => setShowPassword(!showPassword)}
                    aria-label={showPassword ? t.ocultar : t.mostrar}>
                    {showPassword ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
                  </button>
                </div>
              </div>

              <div className="flex justify-end">
                <Link to="/forgot-password" className="olvido">{t.olvido}</Link>
              </div>

              <button type="submit" disabled={isLoading} className="boton">
                {isLoading ? (
                  <>
                    <span className="h-5 w-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                    {t.entrando}
                  </>
                ) : (
                  <>
                    {t.entrar}
                    <ArrowRight className="h-5 w-5" />
                  </>
                )}
              </button>
            </form>

    </MarcoAcceso>
  );
}
